import { isOperationalCockpitMode } from '../routes/execution/executionProjectionConsumerFlags';

export function isOperationalIntelligenceMode(): boolean {
  const v = process.env.REACT_APP_OPERATIONAL_INTELLIGENCE;
  if (v === 'false') return false;
  return v === 'true' || isOperationalCockpitMode();
}
